// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"7478":"8212ed7e","7716":"8212ed7e","8324":"bf58ff60"}[chunkId] + ".chunk.css";
};